/* ============================================================
   Bohemians — Core JS
   Vanilla JS. No framework. Keep this small.
   ============================================================ */
(function () {
  'use strict';

  // ---------- Utility: event delegation ----------
  function on(selector, event, handler, root) {
    (root || document).addEventListener(event, function (e) {
      var target = e.target.closest(selector);
      if (target) handler(e, target);
    });
  }

  // ---------- Format money (INR default; Shopify injects currency via theme.settings) ----------
  function formatMoney(cents, currency) {
    var value = (cents / 100).toFixed(2);
    var symbol = currency === 'USD' ? '$' : '₹';
    return symbol + parseFloat(value).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  window.BohemiansFormatMoney = formatMoney;

  // ---------- Mobile nav ----------
  function initMobileNav() {
    var nav = document.querySelector('.mobile-nav');
    if (!nav) return;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) { nav.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      if (e.target.closest('[data-menu-close]') || e.target === nav) { nav.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    });
  }

  // ---------- Cart drawer ----------
  var cartState = { items: [], count: 0 };

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cartState = data;
        updateCartBadge(data.item_count);
        return data;
      });
  }

  function updateCartBadge(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.setAttribute('data-count', String(count || 0));
      el.textContent = count > 0 ? String(count) : '';
    });
  }

  function escapeAttr(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCart(data) {
    var panel = document.querySelector('[data-cart-content]');
    if (!panel) return;
    var headHTML = '<header class="cart-head">'
      + '<h3>Your cart' + (data.item_count > 0 ? ' (' + data.item_count + ')' : '') + '</h3>'
      + '<button data-cart-close aria-label="Close cart">'
        + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
      + '</button>'
      + '</header>';

    if (!data.items || data.items.length === 0) {
      panel.innerHTML = headHTML
        + '<div class="cart-empty">'
          + '<span class="cart-empty__icon" aria-hidden="true">∞</span>'
          + '<h3 class="h3" style="margin:0;">Your cart is empty</h3>'
          + '<p>Find something you love.</p>'
          + '<a class="btn btn--primary" href="/collections/all" data-cart-close>Shop the collection</a>'
        + '</div>';
      return;
    }
    var lines = data.items.map(function (item) {
      var img = item.image ? '<img src="' + escapeAttr(item.image) + '" alt="' + escapeAttr(item.product_title) + '" loading="lazy">' : '';
      var url = item.url || '/products/' + item.handle;
      return '<div class="cart-line" data-key="' + escapeAttr(item.key) + '">'
        + '<a href="' + escapeAttr(url) + '" class="cart-line__media" data-cart-close>' + img + '</a>'
        + '<div class="cart-line__body">'
          + '<div class="cart-line__head">'
            + '<a href="' + escapeAttr(url) + '" class="cart-line__title" data-cart-close>' + escapeAttr(item.product_title) + '</a>'
            + '<span class="cart-line__price">' + formatMoney(item.final_line_price) + '</span>'
          + '</div>'
          + (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line__variant">' + escapeAttr(item.variant_title) + '</div>' : '')
          + '<div class="cart-line__bottom">'
            + '<div class="cart-line__qty">'
              + '<button type="button" data-cart-qty="-1" aria-label="Decrease">−</button>'
              + '<span>' + item.quantity + '</span>'
              + '<button type="button" data-cart-qty="1" aria-label="Increase">+</button>'
            + '</div>'
            + '<button type="button" class="cart-line__remove" data-cart-remove aria-label="Remove ' + escapeAttr(item.product_title) + '">'
              + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>'
              + '<span>Remove</span>'
            + '</button>'
          + '</div>'
        + '</div>'
      + '</div>';
    }).join('');

    var subtotal = formatMoney(data.total_price);
    panel.innerHTML = headHTML
      + '<div class="cart-lines">' + lines + '</div>'
      + '<footer class="cart-foot">'
        + '<div class="cart-foot__row subtotal"><span>Subtotal</span><span>' + subtotal + '</span></div>'
        + '<p class="cart-foot__notes">Shipping &amp; taxes calculated at checkout.</p>'
        + '<a href="/checkout" class="btn btn--primary">Checkout · ' + subtotal + '</a>'
        + '<a href="/collections/all" class="continue-shopping" data-cart-close>Continue shopping</a>'
      + '</footer>';
  }

  function openCart() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.hidden = false;
    // double-RAF to allow CSS transitions to play
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { drawer.setAttribute('aria-hidden', 'false'); });
    });
    document.body.style.overflow = 'hidden';
    fetchCart().then(renderCart);
  }

  function closeCart() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 320);
  }

  function bumpCartBadge() {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.classList.remove('cart-count--bump');
      void el.offsetWidth; // force reflow
      el.classList.add('cart-count--bump');
    });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
      if (e.target.closest('[data-cart-close]') || e.target.matches('.cart-drawer__scrim')) closeCart();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });

    // /cart page: per-line qty stepper updates input + total live
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-page-qty]');
      if (!btn) return;
      e.preventDefault();
      var line = btn.closest('[data-cart-page-line]');
      if (!line) return;
      var span = line.querySelector('[data-qty]');
      var input = line.querySelector('[data-qty-input]');
      var current = parseInt(span.textContent || '1', 10);
      var delta = parseInt(btn.getAttribute('data-page-qty'), 10);
      var next = Math.max(0, current + delta);
      span.textContent = next;
      if (input) input.value = next;
      // ajax update + re-render totals
      var key = line.getAttribute('data-key');
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: next })
      }).then(function (r) { return r.json(); }).then(function (data) {
        updateCartBadge(data.item_count);
        if (next === 0) line.remove();
        document.querySelectorAll('[data-page-subtotal]').forEach(function (el) { el.textContent = formatMoney(data.total_price); });
        document.querySelectorAll('[data-page-total]').forEach(function (el) { el.textContent = formatMoney(data.total_price); });
        // If empty, reload to show empty state
        if (data.item_count === 0) location.reload();
      });
    });

    // Quantity / remove inside cart drawer
    document.addEventListener('click', function (e) {
      var line = e.target.closest('[data-key]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      if (e.target.closest('[data-cart-qty]')) {
        var delta = parseInt(e.target.closest('[data-cart-qty]').getAttribute('data-cart-qty'), 10);
        var current = parseInt(line.querySelector('.cart-line__qty span').textContent, 10);
        updateLine(key, Math.max(0, current + delta));
      }
      if (e.target.closest('[data-cart-remove]')) updateLine(key, 0);
    });

    // AJAX add to cart
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action$="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var data = new FormData(form);
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.setAttribute('data-loading', '1'); }
      fetch('/cart/add.js', { method: 'POST', body: data, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && res.body.description || 'Add to cart failed');
          return fetchCart().then(function (c) { renderCart(c); bumpCartBadge(); openCart(); });
        })
        .catch(function (err) { alert(err.message); })
        .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('data-loading'); } });
    });

    fetchCart();
  }

  function updateLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { cartState = data; updateCartBadge(data.item_count); renderCart(data); });
  }

  // ---------- Reel modal ----------
  function initReels() {
    var modal = document.querySelector('[data-reel-modal]');
    if (!modal) return;
    var video = modal.querySelector('video');

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-reel-src]');
      if (trigger) {
        var src = trigger.getAttribute('data-reel-src');
        var poster = trigger.getAttribute('data-reel-poster') || '';
        if (video) { video.src = src; video.poster = poster; video.play().catch(function () {}); }
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      if (e.target.closest('[data-reel-close]') || e.target === modal) {
        if (video) { video.pause(); video.src = ''; }
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  }

  // ---------- Product page: variants + gallery ----------
  function initProductForm() {
    var forms = document.querySelectorAll('[data-product-form]');
    forms.forEach(function (form) {
      var variantsJson = form.querySelector('[data-variants-json]');
      if (!variantsJson) return;
      var variants = JSON.parse(variantsJson.textContent);
      var optionSelectors = form.querySelectorAll('[data-option-index]');

      function getSelectedOptions() {
        var selected = [];
        // Skip the fallback size picker — it's a line-item property, not a real Shopify option
        form.querySelectorAll('.variant-group:not(.variant-group--size-fallback)').forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          if (isNaN(idx)) return;
          var chosen = group.querySelector('[aria-checked="true"]');
          selected[idx] = chosen ? chosen.getAttribute('data-value') : null;
        });
        return selected;
      }

      function matchVariant() {
        var opts = getSelectedOptions();
        // If the product has no real variant options (e.g. single-color hidden, or default-only),
        // fall back to the first available variant so the CTA stays enabled.
        var hasSelection = opts.some(function (v) { return v != null; });
        if (!hasSelection) {
          return variants.find(function (v) { return v.available; }) || variants[0];
        }
        return variants.find(function (v) {
          return v.options.every(function (val, i) { return val === opts[i] || opts[i] == null; });
        });
      }

      function updateVariant() {
        var variant = matchVariant();
        var idInput = form.querySelector('[name="id"]');
        var priceEl = form.querySelector('[data-price]');
        var compareEl = form.querySelector('[data-compare-price]');
        var submitBtn = form.querySelector('[type="submit"]');
        if (variant) {
          if (idInput) idInput.value = variant.id;
          if (priceEl) priceEl.textContent = formatMoney(variant.price);
          if (compareEl) compareEl.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
          if (submitBtn) {
            submitBtn.disabled = !variant.available;
            submitBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
          }
          // Variant featured image → jump slider to matching slide (or swap first slide as fallback)
          if (variant.featured_image) {
            var src = variant.featured_image.src || variant.featured_image;
            var gallery = document.querySelector('[data-gallery]');
            if (gallery && typeof gallery.__goToSrc === 'function') {
              gallery.__goToSrc(src);
            }
          }
        } else {
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
        }
      }

      form.addEventListener('click', function (e) {
        var chip = e.target.closest('.variant-chip, .color-swatch, .color-swatch-tile');
        if (!chip || chip.classList.contains('color-swatch-tile--link')) return;
        var group = chip.closest('.variant-group');
        group.querySelectorAll('[aria-checked]').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        chip.setAttribute('aria-checked', 'true');
        // Update color label text if this is a color swatch tile / swatch
        if (chip.classList.contains('color-swatch') || chip.classList.contains('color-swatch-tile')) {
          var label = group.querySelector('[data-color-label]');
          if (label) label.textContent = chip.getAttribute('data-value') || '';
        }
        updateVariant();
      });

      updateVariant();
    });
  }

  // ---------- Product gallery slider ----------
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var viewport = g.querySelector('[data-gallery-viewport]');
      var track = g.querySelector('[data-gallery-track]');
      if (!viewport || !track) return;
      var slides = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-slide]'));
      if (slides.length === 0) return;
      var dots = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-dot]'));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-thumb]'));
      var counter = g.querySelector('[data-gallery-current]');
      var prevBtn = g.querySelector('[data-gallery-prev]');
      var nextBtn = g.querySelector('[data-gallery-next]');
      var index = 0;
      var count = slides.length;

      function go(i) {
        index = Math.max(0, Math.min(count - 1, i));
        track.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
        dots.forEach(function (d, di) {
          var on = di === index;
          d.classList.toggle('is-active', on);
          if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
        thumbs.forEach(function (t, ti) {
          var on = ti === index;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        if (counter) counter.textContent = String(index + 1);
        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= count - 1;
      }
      g.__galleryGo = go;

      if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-index'), 10) || 0); });
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-index'), 10) || 0); });
      });

      // Keyboard nav when focus inside gallery
      g.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      });

      // Touch swipe
      var startX = 0, currentX = 0, dragging = false, startedAt = 0;
      g.__swipedRecently = false;
      viewport.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        currentX = startX;
        dragging = true;
        startedAt = Date.now();
        track.classList.add('is-dragging');
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (!dragging || !e.touches || e.touches.length !== 1) return;
        currentX = e.touches[0].clientX;
        var dx = currentX - startX;
        var w = viewport.offsetWidth || 1;
        var pct = (dx / w) * 100;
        // Resistance at edges
        if ((index === 0 && pct > 0) || (index === count - 1 && pct < 0)) pct *= 0.35;
        track.style.transform = 'translate3d(calc(-' + (index * 100) + '% + ' + pct + '%), 0, 0)';
      }, { passive: true });
      viewport.addEventListener('touchend', function () {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        var dx = currentX - startX;
        var w = viewport.offsetWidth || 1;
        var elapsed = Date.now() - startedAt;
        var threshold = (elapsed < 250) ? w * 0.12 : w * 0.28; // flick vs drag
        // Flag as swipe so the lightbox click handler can ignore this
        if (Math.abs(dx) > 10) {
          g.__swipedRecently = true;
          setTimeout(function () { g.__swipedRecently = false; }, 400);
        }
        if (dx < -threshold) go(index + 1);
        else if (dx > threshold) go(index - 1);
        else go(index); // snap back
      });

      // Variant featured_image → jump to matching slide
      g.__goToSrc = function (src) {
        if (!src) return;
        var base = String(src).split('?')[0].split('/').pop();
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img');
          if (img && img.src && img.src.indexOf(base) !== -1) { go(i); return; }
        }
      };

      go(0);
    });
  }

  // ---------- Image lightbox ----------
  function initLightbox() {
    var modal = document.querySelector('[data-lightbox]');
    if (!modal) return;
    var stage = modal.querySelector('[data-lightbox-stage]');
    var counter = modal.querySelector('[data-lightbox-counter]');
    var thumbs = Array.prototype.slice.call(modal.querySelectorAll('[data-lightbox-thumb]'));
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery || !stage) return;

    var sources = Array.prototype.map.call(gallery.querySelectorAll('[data-gallery-slide] img'), function (img) {
      return img.getAttribute('src');
    });
    if (sources.length === 0) return;
    var current = 0;
    var prevFocus = null;

    function render() {
      var src = sources[current];
      if (src && src.indexOf('width=') !== -1) {
        src = src.replace(/width=\d+/, 'width=2000');
      }
      stage.innerHTML = '<img src="' + src + '" alt="" draggable="false">';
      if (counter) counter.textContent = (current + 1) + ' / ' + sources.length;
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === current); });
    }

    function open(idx) {
      current = typeof idx === 'number' ? idx : 0;
      render();
      prevFocus = document.activeElement;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('[data-lightbox-close]');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (prevFocus && typeof prevFocus.focus === 'function') prevFocus.focus();
    }

    // Thumbnail clicks inside lightbox
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-index'), 10) || 0;
        current = i; render();
      });
    });
    function next() { current = (current + 1) % sources.length; render(); }
    function prev() { current = (current - 1 + sources.length) % sources.length; render(); }

    // Open on main slide click (but ignore if user just swiped)
    gallery.addEventListener('click', function (e) {
      var slide = e.target.closest('[data-gallery-slide]');
      if (!slide) return;
      if (gallery.__swipedRecently) return;
      var idx = parseInt(slide.getAttribute('data-index'), 10) || 0;
      open(idx);
    });

    modal.querySelector('[data-lightbox-close]').addEventListener('click', close);
    modal.querySelector('[data-lightbox-next]').addEventListener('click', next);
    modal.querySelector('[data-lightbox-prev]').addEventListener('click', prev);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target === stage) close();
    });
    document.addEventListener('keydown', function (e) {
      if (modal.getAttribute('aria-hidden') !== 'false') return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowRight') { next(); return; }
      if (e.key === 'ArrowLeft') { prev(); return; }
      // Focus trap — keep Tab cycling within modal
      if (e.key === 'Tab') {
        var focusables = modal.querySelectorAll('button');
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Swipe on lightbox
    var sx = 0, dragging = false;
    stage.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      sx = e.touches[0].clientX; dragging = true;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!dragging) return; dragging = false;
      var ex = (e.changedTouches && e.changedTouches[0].clientX) || sx;
      var dx = ex - sx;
      if (dx < -50) next(); else if (dx > 50) prev();
    });
  }

  // ---------- Sticky mobile buy bar ----------
  function initStickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    if (!bar) return;
    var anchor = document.querySelector('[data-product-form] [type="submit"]');
    if (!anchor) return;

    function update() {
      // Show only on narrow viewports, after user scrolls past ~320px,
      // AND when the main CTA is off-screen
      var rect = anchor.getBoundingClientRect();
      var ctaOff = rect.bottom < 0 || rect.top > window.innerHeight;
      var narrow = window.innerWidth < 900;
      var scrolled = window.scrollY > 320;
      var active = narrow && scrolled && ctaOff;
      bar.setAttribute('aria-hidden', active ? 'false' : 'true');
      document.body.classList.toggle('sticky-buy-active', active);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    var cta = bar.querySelector('[data-sticky-buy-cta]');
    if (cta) cta.addEventListener('click', function () {
      // Proxy to main Add to cart button
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { anchor.click(); }, 320);
    });
  }

  // ---------- Fallback size picker (line item property) ----------
  function initFallbackSize() {
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-fallback-size]');
      if (!chip) return;
      var group = chip.closest('.variant-group--size-fallback');
      if (!group) return;
      group.querySelectorAll('[data-fallback-size]').forEach(function (c) { c.setAttribute('aria-checked', 'false'); });
      chip.setAttribute('aria-checked', 'true');
      var label = group.querySelector('[data-fallback-size-label]');
      var input = group.querySelector('[data-fallback-size-input]');
      var val = chip.getAttribute('data-value');
      var age = chip.getAttribute('data-age');
      if (label) label.textContent = age;
      if (input) input.value = val + ' (' + age + ')';
    });
  }

  // ---------- Quantity stepper ----------
  function initQtyStepper() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var stepper = (minus || plus).closest('[data-qty-stepper]');
      if (!stepper) return;
      var input = stepper.querySelector('[data-qty-input]');
      if (!input) return;
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var max = parseInt(input.getAttribute('max') || '99', 10);
      var current = parseInt(input.value || String(min), 10) || min;
      var next = minus ? current - 1 : current + 1;
      next = Math.max(min, Math.min(max, next));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) { input.value = 1; }
    });
  }

  // ---------- Size chart modal ----------
  function initSizeChart() {
    var modal = document.querySelector('[data-size-chart]');
    if (!modal) return;
    function open() {
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-chart-open]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-size-chart-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
    });
  }

  // ---------- Recently viewed (localStorage) ----------
  function initRecentlyViewed() {
    var STORAGE_KEY = 'bohemians:recently-viewed';
    var MAX = 12;

    function read() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    }
    function push(handle) {
      if (!handle) return;
      var list = read().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      write(list);
    }

    // Seed with current product if on product page
    if (window.BohemiansProduct && window.BohemiansProduct.handle) {
      push(window.BohemiansProduct.handle);
    }

    var section = document.querySelector('[data-recently-viewed]');
    var grid = document.querySelector('[data-recently-viewed-grid]');
    if (!section || !grid) return;

    var currentHandle = (window.BohemiansProduct && window.BohemiansProduct.handle) || '';
    var handles = read().filter(function (h) { return h && h !== currentHandle; }).slice(0, 4);
    // Skip entirely unless the user has genuinely visited at least 2 other products
    if (handles.length < 2) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var visible = products.filter(Boolean);
      if (visible.length < 2) return;
      grid.innerHTML = visible.map(function (p) {
        var img = p.featured_image
          ? '<img src="' + escapeAttr(p.featured_image) + '" alt="' + escapeAttr(p.title) + '" loading="lazy" width="600" height="800">'
          : '';
        var compare = (p.compare_at_price && p.compare_at_price > p.price)
          ? '<span class="compare">' + formatMoney(p.compare_at_price) + '</span>' : '';
        return '<a href="' + escapeAttr(p.url) + '" class="product-card">'
          + '<div class="product-card__media">' + img + '</div>'
          + '<div class="product-card__body">'
            + '<div class="product-card__title">' + escapeAttr(p.title) + '</div>'
            + '<div class="product-card__price">'
              + '<span class="price">' + formatMoney(p.price) + '</span>' + compare
            + '</div>'
          + '</div>'
        + '</a>';
      }).join('');
      section.hidden = false;
    });
  }

  // ---------- Pincode checker ----------
  function initPincode() {
    var widgets = document.querySelectorAll('[data-pincode]');
    widgets.forEach(function (w) {
      var input = w.querySelector('input');
      var btn = w.querySelector('button');
      var status = w.querySelector('[data-pincode-status]');
      var endpoint = w.getAttribute('data-endpoint');
      var defaultDays = parseInt(w.getAttribute('data-default-days') || '5', 10);
      if (!btn) return;

      btn.addEventListener('click', function () {
        var pin = (input.value || '').trim();
        status.className = 'pincode-checker__status';
        if (!/^\d{6}$/.test(pin)) {
          status.textContent = 'Enter a valid 6-digit pincode';
          status.classList.add('pincode-checker__status--bad');
          return;
        }
        status.textContent = 'Checking…';
        if (!endpoint) {
          // Fallback: flat-rate / default-day policy
          setTimeout(function () {
            status.textContent = 'Delivery available — arrives in ' + defaultDays + ' days';
            status.classList.add('pincode-checker__status--ok');
          }, 300);
          return;
        }
        fetch(endpoint + '?pincode=' + pin, { credentials: 'omit' })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function (data) {
            if (data.serviceable) {
              status.textContent = 'Delivery available — arrives in ' + (data.days || defaultDays) + ' days';
              status.classList.add('pincode-checker__status--ok');
            } else {
              status.textContent = 'Not serviceable at this pincode yet';
              status.classList.add('pincode-checker__status--bad');
            }
          })
          .catch(function () {
            status.textContent = 'Delivery available — arrives in ' + defaultDays + ' days';
            status.classList.add('pincode-checker__status--ok');
          });
      });
    });
  }

  // ---------- Newsletter (Shopify customer form) ----------
  // Relies on native {% form 'customer' %} — no JS needed unless AJAX desired.

  // ---------- Reviews "Load more" ----------
  function initReviewsMore() {
    var btn = document.querySelector('[data-reviews-more]');
    var dataEl = document.querySelector('[data-reviews-data]');
    var grid = document.querySelector('[data-reviews-grid]');
    if (!btn || !dataEl || !grid) return;
    var all;
    try { all = JSON.parse(dataEl.textContent); } catch(e) { return; }
    var shown = grid.children.length;
    btn.addEventListener('click', function () {
      var batch = all.slice(shown, shown + 6);
      batch.forEach(function (r) {
        var stars = '';
        var rfull = Math.floor(r.rating || 0);
        for (var i = 1; i <= 5; i++) {
          stars += i <= rfull ? '★' : '<span class="star-empty">★</span>';
        }
        var article = document.createElement('article');
        article.className = 'review-card';
        article.innerHTML =
          '<header class="review-card__head"><span class="stars">' + stars + '</span>' +
          (r.verified ? '<span class="review-verified">✓ Verified</span>' : '') + '</header>' +
          (r.title ? '<h3 class="review-card__title">' + escapeHtml(r.title) + '</h3>' : '') +
          '<p class="review-card__text">' + escapeHtml(r.text || '') + '</p>' +
          '<footer class="review-card__foot"><strong>' + escapeHtml(r.name || '') + '</strong>' +
          (r.date ? '<span class="muted"> · ' + escapeHtml(r.date) + '</span>' : '') + '</footer>';
        grid.appendChild(article);
      });
      shown += batch.length;
      if (shown >= all.length) btn.style.display = 'none';
      else btn.textContent = 'Load more reviews (' + (all.length - shown) + ')';
    });
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---------- IntersectionObserver reveal ----------
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('js-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.fade-in-up').forEach(function (el) { io.observe(el); });
    // Failsafe: ensure everything is visible after 1.5s even if observer hasn't fired
    setTimeout(function () {
      document.querySelectorAll('.fade-in-up').forEach(function (el) { el.classList.add('is-visible'); });
    }, 1500);
  }

  // ---------- Hero video autoplay enforcer ----------
  function initHeroVideo() {
    var videos = document.querySelectorAll('[data-hero-video]');
    videos.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');

      var playing = false;
      var tryPlay = function () {
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.then(function () { playing = true; v.style.opacity = '1'; })
          .catch(function () {
            var resume = function () {
              v.play().then(function () { playing = true; v.style.opacity = '1'; }).catch(function(){});
              cleanup();
            };
            var cleanup = function () {
              document.removeEventListener('touchstart', resume);
              document.removeEventListener('click', resume);
              document.removeEventListener('scroll', resume);
            };
            document.addEventListener('touchstart', resume, { once: true, passive: true });
            document.addEventListener('click', resume, { once: true });
            document.addEventListener('scroll', resume, { once: true, passive: true });
          });
        } else {
          playing = true;
        }
      };
      if (v.readyState >= 2) tryPlay();
      else v.addEventListener('loadeddata', tryPlay, { once: true });

      // Fallback: if video hasn't started playing in 4s, fade it out to show gradient bg
      setTimeout(function () {
        if (!playing && v.paused) {
          v.style.transition = 'opacity .6s ease';
          v.style.opacity = '0';
        }
      }, 4000);

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && v.paused && playing) tryPlay();
      });
    });
  }

  // ---------- Boot ----------
  function boot() {
    initMobileNav();
    initCart();
    initReels();
    initProductForm();
    initGallery();
    initLightbox();
    initStickyBuy();
    initFallbackSize();
    initQtyStepper();
    initSizeChart();
    initRecentlyViewed();
    initPincode();
    initReviewsMore();
    initReveal();
    initHeroVideo();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
